module.exports = __webpack_public_path__ + "static/media/graphImage.4fb6e522.jpg";